/* Fiche produit « avril » (07/10/26, fp-pdp-avril-2026-10-07).
   1. Carte « Complete your ritual · Save 10% » : « Add both to cart » ajoute la variante choisie + le complément (ou le complément
      seul si ce produit est déjà dans le panier), puis ouvre le tiroir. La remise est une remise automatique Shopify (Buy X get Y).
      Le total « Buy both » suit la variante choisie (prix lus sur /products/<handle>.js, devise du marché).
   2. Mesure (traceur maison window.__casaTrack -> app.casa_events, store frenchpress) : événements avril_* listés dans RAPPORT.md.
      Écoute passive (IntersectionObserver, délégation de clics), chaque « vue » n'est envoyée qu'une fois par page.
      pdp_version='avril_v1' est ajouté à tous les événements de la fiche par l'enrobage posé dans snippets/fp-avril-top.liquid.
   Pas d'import('@theme/...') : Shopify regroupe les assets JS et transforme l'import dynamique en require() (erreur). */
(function () {
  if (window.__fpAvril) return; window.__fpAvril = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var cur = function () { return (window.Shopify && Shopify.currency && Shopify.currency.active) || ''; };
  var handle = (location.pathname.match(/\/products\/([^/?#]+)/) || [])[1] || '';
  function T(n, x, k) { try { var f = window.__casaTrack; if (typeof f !== 'function') { if ((k || 0) < 20) setTimeout(function () { T(n, x, (k || 0) + 1); }, 500); return; } f(n, Object.assign({ pdp_version: 'avril_v1', product: handle }, x || {})); } catch (_) {} }
  function once(el, n, props, thr) {
    if (!el || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { io.disconnect(); T(n, typeof props === 'function' ? props() : props); } }); }, { threshold: thr || 0.5 });
    io.observe(el);
  }
  function box() { return document.querySelector('[data-fp-avril-bundle]'); }
  function curVariant() { var i = document.querySelector('.product-information form[data-type="add-to-cart-form"] input[name="id"], .product-information input[name="id"]'); return i ? +i.value : 0; }
  function fmt(c) {
    var lang = document.documentElement.lang || 'en';
    try { return new Intl.NumberFormat(lang, { style: 'currency', currency: cur() || 'USD', minimumFractionDigits: (c % 100 ? 2 : 0) }).format(c / 100); } catch (e) { return (c / 100).toFixed(2); }
  }
  function bundleProps() { var b = box(); return b ? { mate: b.dataset.mate, mate_price: (+b.dataset.matePrice) / 100, both: b.dataset.both === 'true', currency: cur() } : {}; }

  /* ---------- carte « Complete your ritual » ---------- */
  var prices = null;
  function loadPrices() {
    if (prices || !handle) return Promise.resolve(prices);
    return fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) { prices = {}; (p.variants || []).forEach(function (v) { prices[v.id] = v.price; }); return prices; }).catch(function () { return null; });
  }
  function refreshTotal() {
    var b = box(); if (!b) return;
    loadPrices().then(function (pr) {
      var vp = pr && pr[curVariant()]; if (!vp) return;
      var mp = +b.dataset.matePrice;
      var off = (b.dataset.both === 'true' && vp > mp) ? Math.round(vp / 10) : Math.round(mp / 10); // une seule remise s'applique : la plus forte
      var t = b.querySelector('[data-fp-avril-total]'); if (t) t.textContent = fmt(vp + mp - off);
      var s = b.querySelector('[data-fp-avril-sum]'); if (s) s.textContent = fmt(vp + mp);
      var v = b.querySelector('[data-fp-avril-save]'); if (v) v.textContent = fmt(off);
    });
  }
  function inCart() {
    return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { var b = box(); var pid = b && +b.dataset.productId; return (c.items || []).some(function (i) { return i.product_id === pid; }); }).catch(function () { return false; });
  }
  function setLabel() {
    var b = box(); if (!b) return; var l = b.querySelector('.fp-avril-bundle__btn-label');
    inCart().then(function (has) { b.dataset.mainInCart = has ? '1' : ''; l.textContent = has ? l.dataset.labelOne : l.dataset.labelBoth; });
  }
  function openDrawer(n) {
    fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var ev = new Event('cart:update', { bubbles: true });
      ev.detail = { resource: cart, sourceId: 'fp-avril-bundle', data: { source: 'fp-avril-bundle', itemCount: n } };
      document.dispatchEvent(ev);
      setTimeout(function () { var d = document.querySelector('cart-drawer-component'); var dl = d && d.querySelector('dialog'); if (d && !(dl && dl.open) && typeof d.open === 'function') d.open(); }, 500);
    }).catch(function () { location.href = root + 'cart'; });
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var btn = t.closest('[data-fp-avril-bundle-add]');
    if (btn && !btn.disabled) {
      var b = box(); var l = btn.querySelector('.fp-avril-bundle__btn-label'); var old = l.textContent;
      btn.disabled = true; l.textContent = 'Adding...';
      T('avril_bundle_add_click', Object.assign({ main_in_cart: !!b.dataset.mainInCart }, bundleProps()));
      inCart().then(function (has) {
        var items = [{ id: +b.dataset.mateVariant, quantity: 1 }]; var v = curVariant();
        if (!has && v) items.unshift({ id: v, quantity: 1 });
        return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { T('avril_bundle_added', Object.assign({ n_items: items.length, variant: String(v) }, bundleProps())); btn.disabled = false; l.textContent = l.dataset.labelOne; b.dataset.mainInCart = '1'; openDrawer(items.length); });
      }).catch(function () { btn.disabled = false; l.textContent = old === 'Adding...' ? 'Try again' : old; });
      return;
    }
    if (t.closest('.fp-avril-bundle__name, .fp-avril-bundle__media')) T('avril_bundle_mate_click', bundleProps());
    if (t.closest('.fp-avril-guarantee__link')) T('avril_guarantee_details_click', {});
    var sum = t.closest('details > summary');
    if (sum) {
      var d = sum.parentElement; if (d.open) return; // clic qui ferme le volet
      var faq = sum.closest('.fp-avril-faq__list');
      if (faq) { var all = [].slice.call(faq.querySelectorAll('details')); T('avril_faq_open', { i: all.indexOf(d) + 1, q: (sum.textContent || '').trim().slice(0, 80) }); }
      else if (sum.closest('.product-information')) T('avril_accordion_open', { label: (sum.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 60) });
    }
  }, { passive: true });
  document.addEventListener('variant:update', function () { setTimeout(refreshTotal, 50); });
  document.addEventListener('change', function (e) {
    var fs = e.target && e.target.closest && e.target.closest('variant-picker fieldset, variant-picker');
    if (!fs) return;
    setTimeout(refreshTotal, 400);
    var lg = fs.querySelector && fs.querySelector('legend');
    T('avril_variant_change', { option: lg ? (lg.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 30) : '', value: String(e.target.value || '').slice(0, 40) });
  }, { passive: true });
  document.addEventListener('cart:update', function () { setTimeout(setLabel, 300); });

  /* ---------- vues (une fois par page) ---------- */
  function views() {
    once(document.querySelector('.fp-avril-bullets'), 'avril_bullets_view', function () { return { n: document.querySelectorAll('.fp-avril-bullets li').length }; }, 0.6);
    once(box(), 'avril_bundle_view', bundleProps, 0.6);
    once(document.querySelector('.fp-avril-gtrust'), 'avril_gallery_trust_view', {}, 0.6);
    once(document.querySelector('.fp-avril-benefits'), 'avril_benefits_view', {}, 0.3);
    once(document.querySelector('.fp-avril-promise3'), 'avril_promise_view', {}, 0.3);
    once(document.querySelector('.fp-avril-trust'), 'avril_trust_view', {}, 0.5);
    once(document.querySelector('.fp-avril-faq'), 'avril_faq_view', {}, 0.3);
    // comparatif et bandeau « The details » : construits plus tard par fp-pdp.js
    var tries = 0; (function waitCmp() { var c = document.querySelector('[data-fp-pdp-compare]'), s = document.querySelector('[data-fp-pdp-story]'); if (c || s || tries++ > 20) { once(c, 'avril_compare_view', {}, 0.3); once(s, 'avril_details_view', {}, 0.3); return; } setTimeout(waitCmp, 700); })();
    // profondeur de défilement (25/50/75/100 %), une fois chacune
    var marks = [25, 50, 75, 100], sent = {}, tick = false;
    window.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false; var h = document.documentElement.scrollHeight - innerHeight; if (h <= 0) return;
        var pct = Math.round(scrollY / h * 100);
        marks.forEach(function (m) { if (pct >= m && !sent[m]) { sent[m] = 1; T('avril_scroll_depth', { pct: m }); } });
      });
    }, { passive: true });
  }
  function init() { setLabel(); var go = function () { views(); }; if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 3000 }); else setTimeout(go, 1500); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
